import { onUnmounted, ref } from 'vue'

const TOAST_DURATION = 2600

const extractEmail = (href: string) => {
  if (!href.startsWith('mailto:')) return ''

  return decodeURIComponent(href.slice('mailto:'.length).split('?')[0])
}

const copyWithFallback = async (text: string) => {
  if (!text) return false

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // Fall through to the textarea fallback for browsers without clipboard access.
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.top = '-9999px'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()

  try {
    return document.execCommand('copy')
  } catch {
    return false
  } finally {
    textarea.remove()
  }
}

export const useMailto = () => {
  const mailToast = ref('')
  let toastTimer: number | undefined

  const showToast = (message: string) => {
    mailToast.value = message

    if (toastTimer !== undefined) {
      window.clearTimeout(toastTimer)
    }

    toastTimer = window.setTimeout(() => {
      mailToast.value = ''
      toastTimer = undefined
    }, TOAST_DURATION)
  }

  const openMailto = async (href: string) => {
    const email = extractEmail(href)
    const copied = await copyWithFallback(email)

    window.location.href = href

    if (email) {
      showToast(copied ? `Email copied: ${email}` : `Email: ${email}`)
    }
  }

  onUnmounted(() => {
    if (toastTimer !== undefined) {
      window.clearTimeout(toastTimer)
    }
  })

  return {
    mailToast,
    openMailto,
  }
}
